import GtmTracker, { transformPayload } from './trackGtm';

const trackContentClicked = (clickEvent) => {
  const tileId = clickEvent.target.id.split('_')[0];
  if (['th-tile-content-link', 'th-tile-icon-link'].includes(tileId)) {
    const tile = clickEvent.target.closest('.th-content-tile');
    const payload = {
      eventAction: `${tile.getAttribute('data-content-type')}_clicked`,
      eventLabel: tile.getAttribute('data-api-name'),
      eventCategory: `content${tile.getAttribute('data-category-suffix')}`,
    };
    new GtmTracker().track(transformPayload(payload));
  }
};

// Wires GTM tracking on content-tile containers. No-ops on pages without any.
const initContentTileTracking = () => {
  const contentTileContainers = document.querySelectorAll(
    "[data-tracking='content-tile']",
  );
  Array.from(contentTileContainers).forEach((el) => {
    el.addEventListener('click', (e) => trackContentClicked(e));
  });
};

document.addEventListener('DOMContentLoaded', initContentTileTracking);

export { initContentTileTracking, trackContentClicked };
